import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { setPopup } from "../../store/reducers/general.js"
import { PopupRoles } from './popup-roles.jsx'
import { PopupUrgency } from './popup-urgency.jsx'

export function Popup() {
    const dispatch = useDispatch()
    const { popup } = useSelector(state => state.general)

    const closePopup = () => dispatch(setPopup(''))

    useEffect(() => {
        if (popup) document.body.classList.add("no-scroll")
        else document.body.classList.remove("no-scroll")
        return () => document.body.classList.remove("no-scroll")
    }, [popup])

    if (!popup) return <></>

    return <>
        <div className="screen blur" onClick={closePopup}/>
        <section className='popup' style={{ width: 'min-content' }}>
            {popup === 'roles' && <PopupRoles closePopup={closePopup} />}
            {popup === 'urgency' && <PopupUrgency closePopup={closePopup} />}
        </section>
    </>
}